<template>
  <div>


<h2 class="goth">Das-ord</h2>

<div class="grammatikparagrafbredd leftorient">

  <p>Man kan <b>aldrig vara helt säker</b> på om ett tyskt substantiv är ett der-, das- eller die-ord och vilken plural det har
    genom att bara se på hur ordet ser ut eller vad det betyder. Men nedan kommer några av de <b>vanligaste
    reglerna</b> vad som kännetecknar ett das-ord och som kan ge en <b>fingervisning</b> och stämmer i många fall</p>
<br>
<h4>das-ord är ofta...</h4>

  <div class="quasi-p"> &#x2022; Substantiv som betecknar barn / ungar till människor / djur
  </div>


  <div class="ruta">
  <p>
      <i>das Kind <br>barnet</i>
  </p>

  <p>
      <i>das Kalb <br>kalven</i>
  </p>

  </div>

  <br><br>


    <div class="quasi-p"> &#x2022; Gamla ord som är besläktade med svenskan morsvarighet och är neutrum i svenskan
    </div>


    <div class="ruta">
    <p>
        <i>das Wasser<br>vattnet</i>
    </p>
    <p>
        <i>das Haus<br>huset</i>
    </p>
    </div>
  <br><br>



  <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-lein, -chen</b>
  </div>


  <div class="ruta">
    <p>
        <i>das Kaninchen <br>kaninen</i>
    </p>


  <p>
      <i>das Fräulein <br>fröken</i>
  </p>

  <p>
      <i>das Mädchen <br>flickan</i>
  </p>


  </div>
  <p class="mindre">Observera att denna regel som baseras på ordets form ”trumfar” regeln
    om biologiskt kön - de två sista exemplen betecknar ju båda levande varelser av kvinnligt kön men
    är ändå das-ord.</p>
  <br><br>



  <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-en</b>. De är bildade av infinitivformen av motsvarande verb
  </div>


  <div class="ruta">
  <p>
      <i>das Essen <br>maten</i>

  </p>

  <p>
      <i>das Treffen <br>mötet / träffen</i>

  </p>
  </div>
  <br><br>


  <div class="quasi-p"> &#x2022; Substantiv som slutar på <b>-nis, -um, -ment</b>
  </div>


  <div class="ruta">
  <p>
      <i>das Erlebnis <br>upplevelsen</i>
  </p>
  <p>
      <i>das Museum<br>museet</i>
  </p>

  <p>
      <i>das Instrument<br>instrumentet</i>
  </p>
  </div>

  <br>
  <h4>das-ord i plural</h4>
  <p>das-ord ofta <b>-e</b> i plural. </p>
  <p>Många korta das-ord får <b> -er </b> och omljud i plural.
  </p>
  <p>das-ord (och der-ord) som slutar på <b>-en, -el</b> och <b>-er</b> får ingen plural ändelse (men kan ändå få omljud)</p>
  <p>Lånord får ofta <b>-s</b> i plural</p>
  <br>




</div>

</div>







</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "das ord neutrum"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
